/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseField } from './DatabaseField';
import {
    DatabaseFieldFromJSON,
    DatabaseFieldFromJSONTyped,
    DatabaseFieldToJSON,
} from './DatabaseField';
import type { DatabaseFieldPreviewOptions } from './DatabaseFieldPreviewOptions';
import {
    DatabaseFieldPreviewOptionsFromJSON,
    DatabaseFieldPreviewOptionsFromJSONTyped,
    DatabaseFieldPreviewOptionsToJSON,
} from './DatabaseFieldPreviewOptions';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';

/**
 * Verweise auf andere Datensaetze — etwa um Tickets miteinander zu verknuepfen.
 * ABGRENZUNG ZU `DatabaseParentEntryField`: An der Oberflaeche sind beide gleich (einen Datensatz auswaehlen), im Kern nicht. Die Zuordnung zur Hauptdatenbank setzt `belongsTo` und ist STRUKTURELL: Sie entscheidet, unter welchem Eltern-Datensatz eine Zeile in der Master-Detail-Ansicht erscheint, und es gibt genau eine davon. Dieses Feld hier ist ein gewoehnlicher Feldwert, traegt beliebig viele Verweise und hat keine Wirkung auf die Anzeige-Struktur. `belongsTo` dafuer zu missbrauchen haette Tickets aus der Uebersicht ihrer eigenen Datenbank verschwinden lassen.
 * Der Wert ist eine Liste von Datensatz-Kennungen.
 * @export
 * @interface DatabaseEntryLinkField
 */
export interface DatabaseEntryLinkField extends DatabaseField {
    /**
     * Aus welcher Datenbank ausgewaehlt wird. Ohne Angabe die eigene — der haeufige Fall (Ticket verweist auf Ticket).
     * @type {string}
     * @memberof DatabaseEntryLinkField
     */
    targetDatabaseId?: string;
    /**
     * Welches Feld der Ziel-Datenbank die Auswahl beschriftet. Ohne Angabe deren Vorschaufelder.
     * @type {string}
     * @memberof DatabaseEntryLinkField
     */
    labelFieldId?: string;
    /**
     * Wechselseitig: Wird Ticket 1 mit Ticket 5 verknuepft, entsteht auch bei Ticket 5 ein Verknuepfungs-Datensatz, der auf 1 zeigt.
     * ZWEI ECHTE DATENSAETZE, nicht eine gedrehte Anzeige eines einzigen (Entscheidung des Betreibers 31.08.2026). Beide Seiten sind normal bearbeit- und loeschbar; eine zeilenweise Schreibsperre, die die Ein-Datensatz-Fassung gebraucht haette, gibt es in den Listen nicht.
     * DER SPIEGEL ENTSTEHT IM BACKEND, nicht im Browser — sonst entstuenden Verknuepfungen ohne Gegenstueck, sobald jemand ueber die API schreibt.
     * Nur sinnvoll an einem Feld in einer UNTERdatenbank, dessen Ziel-Datenbank die Elterndatenbank ist: Der Spiegel ist ein Datensatz derselben Unterdatenbank, der am ausgewaehlten Eltern-Datensatz haengt. Vorgabe AUS.
     * @type {boolean}
     * @memberof DatabaseEntryLinkField
     */
    bidirectional?: boolean;
    /**
     * Mehrere Verweise erlauben. Vorgabe ist true — ein Ticket haengt selten an genau einem anderen.
     * @type {boolean}
     * @memberof DatabaseEntryLinkField
     */
    multiple?: boolean;
}

/**
 * Check if a given object implements the DatabaseEntryLinkField interface.
 */
export function instanceOfDatabaseEntryLinkField(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseEntryLinkFieldFromJSON(json: any): DatabaseEntryLinkField {
    return DatabaseEntryLinkFieldFromJSONTyped(json, false);
}

export function DatabaseEntryLinkFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseEntryLinkField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseFieldFromJSONTyped(json, ignoreDiscriminator),
        'targetDatabaseId': !exists(json, 'targetDatabaseId') ? undefined : json['targetDatabaseId'],
        'labelFieldId': !exists(json, 'labelFieldId') ? undefined : json['labelFieldId'],
        'bidirectional': !exists(json, 'bidirectional') ? undefined : json['bidirectional'],
        'multiple': !exists(json, 'multiple') ? undefined : json['multiple'],
    };
}

export function DatabaseEntryLinkFieldToJSON(value?: DatabaseEntryLinkField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseFieldToJSON(value),
        'targetDatabaseId': value.targetDatabaseId,
        'labelFieldId': value.labelFieldId,
        'bidirectional': value.bidirectional,
        'multiple': value.multiple,
    };
}

